import { shopManagerApi } from 'configs';
import { convertToSearchCriteria } from 'helpers/api';
import api from 'configs/api';


import {
  getEavAttributeStart,
  getEavAttributeSuccess,
  getEavAttributeFailed,
  addEavAttributeStart,
  addEavAttributeSuccess,
  addEavAttributeFailed,
  updateEavAttributeStart,
  updateEavAttributeSuccess,
  updateEavAttributeFailed,
  deleteEavAttributeStart,
  deleteEavAttributeSuccess,
  deleteEavAttributeFailed,
  getQuoteCustomersCountByMarketingSegmentStart,
  getQuoteCustomersCountByMarketingSegmentSuccess,
  getQuoteCustomersCountByMarketingSegmentFailed,
} from 'redux/actions/eavAttributes';


export const getEavAttributeApi = async ({dispatch, entityType, attributeCode}) => {
  try {
    dispatch(getEavAttributeStart());
    const {data} = await api.get(`${shopManagerApi}/store/eav/attribute/${entityType}/${attributeCode}`);
    dispatch(getEavAttributeSuccess(data));
  } catch (e) {
    dispatch(getEavAttributeFailed(e));
  }
};

export const addEavAttributeApi = async ({dispatch, entityType, attributeCode, option}) => {
  try {
    dispatch(addEavAttributeStart());
    const {data} = await api.post(`${shopManagerApi}/store/eav/attribute/option`, { entityType, attributeCode, option });
    dispatch(addEavAttributeSuccess(data));
  } catch (e) {
    dispatch(addEavAttributeFailed(e));
  }
};

export const updateEavAttributeApi = async ({dispatch, entityType, attributeCode, option}) => {
  try {
    dispatch(updateEavAttributeStart());
    const {data} = await api.post(`${shopManagerApi}/store/eav/attribute/option`, { entityType, attributeCode, option });
    dispatch(updateEavAttributeSuccess(data));
  } catch (e) {
    dispatch(updateEavAttributeFailed(e));
  }
};

export const deleteEavAttributeApi = async ({dispatch, entityType, attributeCode, optionId}) => {
  try {
    dispatch(deleteEavAttributeStart());
    await api.delete(`${shopManagerApi}/store/eav/attribute/option/${entityType}/${attributeCode}/${optionId}`);
    dispatch(deleteEavAttributeSuccess(optionId));
  } catch (e) {
    dispatch(deleteEavAttributeFailed(e));
  }
};

export const getQuoteCustomersCountByMarketingSegmentsApi = async ({
  dispatch,
  sortDirection,
  sortField,
  pageSize,
  currentPage,
  searchConditions,
  field,
  conditionType,
  marketingSegments,
}) => {
  try {
    dispatch(getQuoteCustomersCountByMarketingSegmentStart());
    const promises = marketingSegments.map(async (segment) => {
      const params = convertToSearchCriteria({
        searchConditions,
        filterConditions: [
          {
            field,
            conditionType,
            value: `%${segment.value}%`
          }
        ],
        pageSize,
        currentPage,
        sortField,
        sortDirection,
      });

      const response = await api.get(`${shopManagerApi}/store/customers?${params}`);
      return {
        marketingSegment: segment,
        customerData: response.data.customers
      };
    });

    const data = await Promise.all(promises);
    dispatch(getQuoteCustomersCountByMarketingSegmentSuccess(data));
  } catch (e) {
    dispatch(getQuoteCustomersCountByMarketingSegmentFailed(e));
  }
};
